import { render, staticRenderFns } from "./permit.vue?vue&type=template&id=36658ba8&scoped=true&"
import script from "./permit.vue?vue&type=script&lang=ts&"
export * from "./permit.vue?vue&type=script&lang=ts&"
import style0 from "./permit.vue?vue&type=style&index=0&id=36658ba8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36658ba8",
  null
  
)

export default component.exports